define(['underscore', 'text!./templates/basler-checkbox.html'],
    (_, templateStr) => {

        return [() => {
            return {
                restrict: 'E',
                template: templateStr,
                scope: {
                    /** Model (value) to select. */
                    model: '=',
                    /** labelText. */
                    labelText: '=',
                    /** linkText */
                    linkText: '=',
                    /** linkHref */
                    linkHref: '=',
                    /** Should the element be disabled */
                    disabled: '=',
                    /** Function to be called when the model changes */
                    onChange: '&',
                },
                link: function ($scope, element, attr, vm) {
                    $scope.toggleCheckbox = () => {
                        $scope.model = !$scope.model;
                    }
                }
            };
        }];
    }
);



// WEBPACK FOOTER //
// ../common/js/src/edge/platform/basler/BaslerCheckbox.js